import React, { useState } from "react";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Tooltip,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import {
  Business as BusinessIcon,
  Check as CheckIcon,
  ArrowDropDown as ArrowDropDownIcon,
} from "@mui/icons-material";
import { useEmpresa } from "@contexts/EmpresaContext";

// Seletor da empresa ativa exibido na TopBar.
// - 0 empresas: nada é exibido.
// - 1 empresa: mostra apenas o nome (sem dropdown).
// - 2+ empresas: dropdown para trocar a empresa ativa.
const EmpresaSelector = () => {
  const { empresas, empresaAtiva, selecionarEmpresa } = useEmpresa();
  const [anchorEl, setAnchorEl] = useState(null);

  if (!empresas || empresas.length === 0) {
    return null;
  }

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (id) => {
    selecionarEmpresa(id);
    handleClose();
  };

  // Apenas uma empresa: exibe somente o nome.
  if (empresas.length === 1) {
    return (
      <Box
        sx={{
          display: { xs: "none", sm: "flex" },
          alignItems: "center",
          gap: 1,
          mr: 1,
          color: "inherit",
        }}
      >
        <BusinessIcon fontSize="small" />
        <Typography variant="body2" noWrap sx={{ maxWidth: 220 }}>
          {empresas[0].nome}
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Tooltip title="Trocar empresa ativa">
        <Button
          color="inherit"
          onClick={handleOpen}
          startIcon={<BusinessIcon />}
          endIcon={<ArrowDropDownIcon />}
          aria-haspopup="menu"
          aria-label="Selecionar empresa ativa"
          sx={(theme) => ({
            mr: 1,
            textTransform: "none",
            maxWidth: 260,
            backgroundColor: alpha(theme.palette.common.white, 0.12),
            border: `1px solid ${alpha(theme.palette.common.white, 0.18)}`,
            "&:hover": {
              backgroundColor: alpha(theme.palette.common.white, 0.2),
            },
          })}
        >
          <Typography variant="body2" noWrap sx={{ maxWidth: 160 }}>
            {empresaAtiva?.nome || "Selecionar empresa"}
          </Typography>
        </Button>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        PaperProps={{ sx: { mt: 1, minWidth: 240 } }}
      >
        {empresas.map((empresa) => {
          const isAtiva = empresaAtiva?.id === empresa.id;
          return (
            <MenuItem
              key={empresa.id}
              selected={isAtiva}
              onClick={() => handleSelect(empresa.id)}
            >
              <ListItemIcon>
                {isAtiva ? (
                  <CheckIcon fontSize="small" color="primary" />
                ) : (
                  <BusinessIcon fontSize="small" />
                )}
              </ListItemIcon>
              <ListItemText
                primary={empresa.nome}
                primaryTypographyProps={{ noWrap: true }}
              />
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default EmpresaSelector;
